import { Grid, TextField, Typography, Box } from '@mui/material';

interface DisabledTextInput {
    label: string;
    value: string;
    size?: number;
    warning?: string;
}

export const FormDisabledText = ({ label, value, size, warning }: DisabledTextInput) => {
    return (
        <Grid item md={size ?? 6} xs={12} sm={12}>
            <Box display='flex' flexDirection='column' gap={0}>
                <Typography
                    variant='body2'
                    color={warning ? 'error' : 'text.primary'}
                    fontWeight={1000}
                    sx={{ pl: 0.5 }}>
                    {label}
                </Typography>
                <TextField
                    variant='outlined'
                    value={value}
                    size='small'
                    disabled
                    error={Boolean(warning)}
                    helperText={warning}
                    fullWidth
                    sx={{
                        backgroundColor: '#f9f9f9',
                        '& .MuiOutlinedInput-root.Mui-disabled': {
                            backgroundColor: '#f9f9f9',
                        },
                        '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: warning ? '#d32f2f' : '#e0e0e0',
                        },
                        '& .MuiFormHelperText-root': {
                            ml: 0,
                            color: warning ? '#d32f2f' : 'text.secondary',
                        },
                    }}
                />
            </Box>
        </Grid>
    );
};
